













import Vue from 'vue'
import Item from '@/components/parsers/Item.vue'
import { darkColors, lightColors } from '@/config/colors'

export default Vue.extend({
  name: 'ItemsParser',

  components: { Item },

  mounted () {
    this.adjustCardBackground()
  },

  computed: {
    getParseItems (): Array<Record<string, unknown>> {
      if (
        typeof this.$props.mainData === 'object' &&
        Object.prototype.hasOwnProperty.call(this.$props.mainData, 'items')
      ) {
        return this.$props.mainData.items
      }
      return this.$props.mainData
    },
    isFirstItem (): boolean {
      return typeof this.$props.itemIdx === 'number' && this.$props.itemIdx === 0
    },
    itemHasElements (): boolean {
      if (!this.getParseItems) {
        return false
      }
      const mainData = this.getParseItems[0]
      return Object.prototype.hasOwnProperty.call(mainData, 'elements')
    }
  },

  methods: {
    /*
    This method should be called on mount
    Card background is based on the first element the API returns. There are certain rules:
    1) If the first element has no 'style' property, uses default background (white)
    In all other cases, the first element has the 'style' property and the priority is:
    2) If the theme is 'none' or 'defaultFullScreen', but no 'pageBackground' is set, uses default background
    3) In all other cases, priority is the 'pageBackground' property if it exists, or default otherwise
    */
    adjustCardBackground (): void {
      if (typeof this.getParseItems !== 'undefined') {
        const first = this.getParseItems[0] as Record<string, Record<string, unknown>>
        this.adjustCardByFirstItem(first)
      } else {
        this.$store.dispatch('changeCardBackground', this.$vuetify.theme.dark ? darkColors.appDefault : lightColors.white)
      }
    },
    adjustCardByFirstItem (first: Record<string, Record<string, unknown>>): void {
      if (Object.prototype.hasOwnProperty.call(first, 'style')) {
        const style = first.style as Record<string, string>
        if ((style.theme === 'none' || style.theme === 'defaultFullScreen') &&
          !Object.prototype.hasOwnProperty.call(style, 'pageBackground')
        ) {
          this.$store.dispatch('changeCardBackground', this.$vuetify.theme.dark ? darkColors.appDefault : lightColors.appDefault)
          return
        } else {
          this.adjustLeftViewBackground(style)
          this.$store.dispatch('changeCardBackground', this.$vuetify.theme.dark ? darkColors.appDefault : (style.pageBackground || lightColors.appDefault))
          return
        }
      }
      this.$store.dispatch('changeCardBackground', this.$vuetify.theme.dark ? darkColors.appDefault : lightColors.white)
    },
    /*
    Left view background is also configurable based on certain rules. As only 1 left view can be active
    at any time, background can be set only if the user navigates to it from the 'main' view.
    Background color will be changed only if the 'theme' property is 'defaultFullScreen' and
    if the 'pageBackground' property is set. In all other cases, default background will be used.
    */
    adjustLeftViewBackground (style: Record<string, string>) {
      if (this.$store.getters.getViewState === 'main') {
        const root = document.querySelector(':root') as HTMLBodyElement
        if (
          style.theme &&
          style.theme === 'defaultFullScreen' &&
          style.pageBackground &&
          this.isFirstItem
        ) {
          root.style.setProperty('--app-default', this.$vuetify.theme.dark ? darkColors.appDefault : style.pageBackground)
          return
        }
        root.style.setProperty('--app-default', this.$vuetify.theme.dark ? darkColors.appDefault : lightColors.appDefault)
      }
    },
    /*
    groupedTop and groupedBottom themes should come in pair, but that's not always the case.
    We need to check if the themes have something in between, and add padding to the groupedBottom item.
    If they are next to each other, no padding should be added.
    */
    shouldAddPaddingBottomGrouped (item: Record<string, unknown>): boolean {
      if (Object.prototype.hasOwnProperty.call(item, 'style')) {
        const style = item.style as Record<string, string>
        if (
          style.theme && style.theme === 'groupedBottom' &&
          this.$props.groupedTopIdx &&
          this.$props.groupedTopIdx + 1 !== this.$props.itemIdx
        ) {
          return true
        }
      }
      return false
    }
  },

  props: {
    mainData: {
      required: true
    },
    firstItemKeyAfterHeaderTheme: {
      type: String,
      default: ''
    },
    itemIdx: {
      required: false
    },
    groupedTopIdx: {
      required: false,
      type: Number
    }
  }
})
